//import { GetFormattedProductData } from '@/models/ProductOverviewModel'
import { getOrderOverview, getOrderOfflineDetails, getOrderOnlineDetails } from '@/services/Order/OrderOverview/orderOverview'
import { useQueries } from '@tanstack/react-query'
import { useParams, useSearchParams } from 'react-router-dom'

export const useOrderOverview = () => {
  const { id } = useParams();

const [{ data, isLoading }] = useQueries({
    queries: [{ queryKey: ['Order', id], queryFn: () => getOrderOverview(`${id}`) }],
  })
  return {
    orderOverviewData: data || {},
    isLoading: isLoading,
  }
}

export const useOrderOfflineDetails = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const typeOfOrder = searchParams.get('typeOfOrder');
  
  const [{ data, isLoading }] = useQueries({
    queries: [{ 
      queryKey: ['ORDER_OFFLINE', id, typeOfOrder], 
      queryFn: () => getOrderOfflineDetails(`orderId=${id}`, typeOfOrder) 
    }],
  })
  return {
    orderOverviewData: data || {},
    isLoading: isLoading,
  }
}

export const useOrderOnlineDetails = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const typeOfOrder = searchParams.get('typeOfOrder');

  const [{ data, isLoading }] = useQueries({
    queries: [{ 
      queryKey: ['ORDER_ONLINE', id, typeOfOrder], 
      queryFn: () => getOrderOnlineDetails(`orderId=${id}`, typeOfOrder) 
    }],
  })
  return {
    orderOverviewData: data || {},
    isLoading: isLoading,
  }
}
